export class GetEventsAction {
  static readonly type = "[Actualites] Get Events";
}
